/**
 * 已被引入活动业务代码，不可通用
 */
import { useCoupon } from '@/components/js/lalaPrize/lalaCoupon';
import { urlHandle, urlDriverHandle, gotoPage } from '../helper';

export const LINK_INTERNALS = {
  1: {
    id: 1,
    name: '下单页',
    redirectType: 'businessTab',
    businessType: 1
  },
  2: {
    id: 2,
    name: '下单页大货车tab',
    redirectType: 'businessTab',
    businessType: 3
  },
  3: {
    id: 3,
    name: '下单页搬家tab',
    redirectType: 'businessTab',
    businessType: 2
  },
  4: {
    id: 4,
    name: '下单页物流tab',
    redirectType: 'businessTab',
    businessType: 5
  },
  5: {
    id: 5,
    name: '下单页企业tab',
    redirectType: 'link',
    linkName: 'enterprise_home'
  },
  101: {
    id: 101,
    name: '司机认证页',
    redirectType: 'driverBusiness'
  },
  102: {
    id: 102,
    name: '抢单大厅',
    redirectType: 'driverBusiness'
  }
};
const DRIVER_LINK_INTERNALS = {
  101: {
    id: 101,
    name: '司机认证页',
    redirectType: 'driverBusiness',
    taskCode: 'complete_driver_verification'
  },
  102: {
    id: 102,
    name: '抢单大厅',
    redirectType: 'driverBusiness',
    taskCode: 'order_complete_n'
  }
};
export default {
  data() {
    return {
      text: '您已完成任务'
    };
  },
  props: {
    linkType: String,
    href: String,
    linkId: Number,
    taskCompletion: {
      type: Array,
      required: false
    },
    isJumpDappWeb: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    isToast() {
      console.log(this.taskCompletion, this.isJumpDappWeb, 'taskCompletion');
      let item = this.taskCompletion.filter(
        task => DRIVER_LINK_INTERNALS[this.linkId].taskCode == task.taskCode
      );
      console.log(item, 'taskCompletion');
      if (item.length > 0) {
        if (item[0].taskCode === 'complete_driver_verification') {
          // isJumpDappWeb true 代表需要跳转 false 代表不需要跳转  要提示  您已认证，相同账号无法重复认证。
          this.text = '您已认证,相同账号无法重复认证';
          return this.isJumpDappWeb == false;
        }
        return item[0].status == 1;
      }
      return false;
    }
  },
  methods: {
    handleRedirect() {
      if (this.linkType === 'internal') {
        const linkDescObj =
          LINK_INTERNALS[this.linkId] || DRIVER_LINK_INTERNALS[this.linkId];
        switch (linkDescObj.redirectType) {
          case 'businessTab':
            useCoupon(linkDescObj.businessType);
            break;
          case 'link':
            gotoPage(linkDescObj.linkName);
            break;
          case 'driverBusiness':
            urlDriverHandle(linkDescObj.id, this.isToast, this.text);
            break;
        }
        return;
      }
      if (this.linkType === 'custom') {
        urlHandle(this.href);
      }
    }
  }
};
